export default "__VITE_ASSET__BIDUcL$t__"